import { useEffect, useState } from 'react';
import { Breakpoint, BreakpointType, MEDIA_QUERIES, detectBreakpoint } from '../theme/breakpoints';

/**
 * Reactive breakpoint hook — single source of truth via `detectBreakpoint()`
 * from `theme/breakpoints.ts` (JS mirror of the PostCSS `@custom-media`
 * tokens). Subscribes to every breakpoint media query so any boundary cross
 * fires an update.
 */
export const useBreakpoint = (): BreakpointType => {
    const [breakpoint, setBreakpoint] = useState(detectBreakpoint);
    useEffect(() => {
        const queries = Object.values(MEDIA_QUERIES).map((q) => window.matchMedia(q));
        const update = () => setBreakpoint(detectBreakpoint());
        queries.forEach((mq) => mq.addEventListener('change', update));
        return () => queries.forEach((mq) => mq.removeEventListener('change', update));
    }, []);
    return breakpoint;
};

/** Phones (portrait or landscape) — the tightest layouts that take the SMALL
 *  size presets across the design system. */
export const isMobileBreakpoint = (breakpoint: BreakpointType): boolean =>
    breakpoint === Breakpoint.MOBILE_PORTRAIT || breakpoint === Breakpoint.MOBILE_LANDSCAPE;
